import { render, staticRenderFns } from "./CheckIcon.component.vue?vue&type=template&id=65075a46&scoped=true&lang=pug"
import script from "./CheckIcon.component.vue?vue&type=script&lang=ts"
export * from "./CheckIcon.component.vue?vue&type=script&lang=ts"
import style0 from "./CheckIcon.component.vue?vue&type=style&index=0&id=65075a46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65075a46",
  null
  
)

export default component.exports